import axios from 'axios';
import LoginService from '../acesso/login.service'
import ReportService from '../report.service';

const API_URL = process.env.VUE_APP_BASE_URL + '/api/aviso/';

class AvisoService {
    constructor() {
        LoginService.currentUser.subscribe(data => {
            this.headers = {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + (data ? data.token : '')
            };
        });
    }

    findAllNaoLidas(idCliente, idUsuario, idContribuinte) {
        return axios.get(API_URL + 'allNaoLidos?idCliente=' + idCliente + '&idUsuario=' + idUsuario + "&idContribuinte=" + idContribuinte, { headers: this.headers });
    }

    findAllAvisos(idCliente, dataIni, dataFin, situacao) {
        return axios.get(API_URL + 'allAvisos?idCliente=' + idCliente + (dataIni ? '&dataIni=' + dataIni : '') + (dataFin ? '&dataFin=' + dataFin : '') + (situacao && situacao !== 'null' && situacao !== 'undefined' ? '&situacao=' + situacao : ''), { headers: this.headers });
    }

    findById(id) {
        return axios.get(API_URL + id, { headers: this.headers });
    }

    save(avisoUsuarioLeitura) {
        return axios.post(API_URL, JSON.stringify(avisoUsuarioLeitura),
            { headers: this.headers });
    }

    saveAviso(aviso) {
        return axios.post(API_URL + 'saveAviso', JSON.stringify(aviso), { headers: this.headers });
    }

    desativarAviso(aviso) {
        return axios.post(API_URL + 'desativarAviso?saveAviso', JSON.stringify(aviso), { headers: this.headers });
    }

    downloadAnexoAviso(id) {
        this.findById(id).then(response => {
            const aviso = response.data;
            ReportService.downloadFromBytes(aviso.file, aviso.nomeArquivo, aviso.tipoArquivo);
        }).catch(error => {
            console.error('Erro ao baixar anexo do aviso:', error);
        });
    }

}

export default new AvisoService();